var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33009)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#4096D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3617 5.62501H10.7083L9.62494 8.34188H6.20831V6.94294H9.62494L10.125 5.62501H4.95113C4.88707 5.62471 4.82552 5.64983 4.77996 5.69485C4.73441 5.73988 4.70857 5.80114 4.70812 5.86519V8.34132H3.87562L3.375 9.65869H4.70812V12.132C4.70812 12.2659 4.81837 12.375 4.9545 12.375H7.45819L7.95825 11.0582H6.20831V9.65813H9.04162L7.95825 12.375H9.62494L10.7916 9.65813H14.3803C14.5153 9.65813 14.625 9.55013 14.625 9.41682V5.88432C14.6244 5.81504 14.5964 5.74884 14.547 5.70022C14.4976 5.65161 14.431 5.62456 14.3617 5.62501ZM13.2086 8.13376C13.2086 8.24851 13.1147 8.34188 12.9983 8.34188H11.2916L11.8749 6.94351H12.9971C13.0527 6.9429 13.1062 6.96436 13.146 7.00316C13.1857 7.04197 13.2084 7.09496 13.2092 7.15051L13.2086 8.13376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33009"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuel);
export default __webpack_public_path__ + "static/media/fuel.09dbfd978d298ef59363e77926e82766.svg";
export { ForwardRef as ReactComponent };